<h2 mat-dialog-title>{{ editOrAddDialogKey | t }}</h2>
<mat-dialog-content class="mat-typography">
  <sn-form [fields]="formFields" [model]="formModel"></sn-form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" type="button" (click)="close()">{{ 'common.cancel' | t }}</button>
  <button mat-button color="success" type="submit" (click)="submit()" cdkFocusInitial>{{ 'common.save' | t }}</button>
</mat-dialog-actions>
